<div id="sidebar-collapse" class="sidebar">

    <div class="admin-block d-flex" style="align-items: center;">
        <div>
            <img src="./../../../../assets/img/dash/klmlogo.png" class="img-circle" width="45px" />
        </div>
        <div class="admin-info">
            <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['CASE']}}</div>
        </div>
    </div>
    <ul class="side-menu metismenu">
        <li>
            <a class="text-decoration-none" routerLinkActive="active" (click)="refreshCol()"
                routerLink="/case/case-index"><i class="sidebar-item-icon fa fa-th-large"></i>
                <span class="nav-label"> Dashboard </span>
            </a>
        </li>
        <li routerLinkActive="active">
            <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseAdmin"
                aria-expanded="false" aria-controls="collapseAdmin"><i class="sidebar-item-icon fa fa-database"></i>
                <span class="nav-label">Administration</span><i class="fa fa-angle-left arrow"></i></a>
            <ul class="nav-2-level collapse" id="collapseAdmin" data-bs-parent="#sidebar-collapse">
                <div id="adminParent">
                    <li>
                        <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#set"
                            aria-expanded="false" aria-controls="set">
                            <span class="nav-label">Master Data</span><i class="fa fa-angle-left arrow"></i></a>
                        <ul class="nav-3-level collapse" id="set" data-bs-parent="#adminParent">
                            <li>
                                <a routerLink="/case/case-setting/code-value" routerLinkActive="active">Code Value</a>
                            </li>
                            <li>
                                <a routerLink="/case/case-setting/field" routerLinkActive="active">Field</a>
                            </li>
                            <li>
                                <a routerLink="/case/case-setting/hierachy" routerLinkActive="active">
                                    Hierachy
                                </a>
                            </li>

                        </ul>
                    </li>

                    <li>
                        <a lass="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#sec"
                            aria-expanded="false" aria-controls="sec">
                            <span class="nav-label">Security</span><i class="fa fa-angle-left arrow"></i></a>
                        <ul class="nav-3-level collapse" id="sec" data-bs-parent="#adminParent">
                            <li>
                                <a routerLink="/case/administration/roles" routerLinkActive="active">
                                    Role
                                </a>
                            </li>
                            <li>
                                <a routerLink="/case/administration/users" routerLinkActive="active">User</a>
                            </li>
                            <li>
                                <a routerLink="/case/administration/data-assignment" routerLinkActive="active">
                                    Data Assignment
                                </a>
                            </li>
                            <li>
                                <a routerLink="/case/administration/workflow" routerLinkActive="active">
                                    Workflow
                                </a>
                            </li>
                        </ul>
                    </li>
                </div>
            </ul>
        </li>




    </ul>
</div>